import React, { useEffect, useState } from 'react';
import ReactStars from 'react-rating-stars-component';
import styled from 'styled-components';

import Modal from '../../../Components/UI/Modal/Modal';
import { formatDate } from '../../../Utils/date';
import { subscribeProjectReview } from '../../../Services/trustReviews';

const SeeReviewArtisan = ({ show, close, demand }) => {
  const [review, setReview] = useState(null);
  const [loading, setLoading] = useState(false);
  const demandId = demand?.demand_id;
  const clientId = demand?.user_id;

  useEffect(() => {
    if (!show || !demandId || !clientId) return undefined;
    setLoading(true);
    return subscribeProjectReview(
      { demandId, reviewerId: clientId },
      (next) => { setReview(next?.status === 'published' ? next : null); setLoading(false); },
      () => setLoading(false),
    );
  }, [clientId, demandId, demand?.review_exchange?.published, show]);

  const pending = Boolean(demand?.review_exchange?.client_submitted && !review);

  return (
    <Modal opened={show} close={close}>
      <Header>
        <div><Eyebrow>Retour client</Eyebrow><Title>Votre évaluation vérifiée</Title></div>
        <CloseButton type="button" aria-label="Fermer" onClick={close}>×</CloseButton>
      </Header>

      {loading ? (
        <Empty>Chargement de l’avis…</Empty>
      ) : review ? (
        <ReviewCard>
          <StarsRow>
            <ReactStars count={5} value={Number(review.rating) || 0} size={28} edit={false} isHalf={false} activeColor="#c0a375" />
            <Score>{Number(review.rating) || 0}/5</Score>
          </StarsRow>
          <ReviewText>{review.comment || 'Le client n’a pas ajouté de commentaire.'}</ReviewText>
          <Meta>
            <span>{review.project_title || demand?.description || 'Prestation'}</span>
            {review.published_at && <span>Publié le {formatDate(review.published_at)}</span>}
          </Meta>
        </ReviewCard>
      ) : pending ? (
        <Pending>L’avis du client a bien été reçu. Il reste masqué jusqu’à votre propre avis ou jusqu’à la fin du délai de publication.</Pending>
      ) : (
        <Empty>Aucun avis client public n’est encore disponible pour cette intervention.</Empty>
      )}

      <Actions><PrimaryButton type="button" onClick={close}>Fermer</PrimaryButton></Actions>
    </Modal>
  );
};

const Header = styled.header`display:flex;align-items:flex-start;justify-content:space-between;gap:1rem;margin-bottom:1.2rem;`;
const Eyebrow = styled.div`margin-bottom:.35rem;color:#a88a5d;font-size:.76rem;font-weight:900;letter-spacing:.12em;text-transform:uppercase;`;
const Title = styled.h2`margin:0;color:#111;font-size:clamp(1.35rem,4vw,1.9rem);`;
const CloseButton = styled.button`width:2.5rem;height:2.5rem;flex:0 0 auto;border:0;border-radius:50%;background:#f1ece5;color:#111;font:inherit;font-size:1.6rem;cursor:pointer;`;
const ReviewCard = styled.section`padding:1.2rem;border:1px solid #e4e9ed;border-radius:1rem;background:#faf8f4;`;
const StarsRow = styled.div`display:flex;flex-wrap:wrap;align-items:center;gap:.8rem;`;
const Score = styled.strong`color:#111;font-size:1.05rem;`;
const ReviewText = styled.p`margin:1rem 0;color:#111;line-height:1.7;white-space:pre-wrap;`;
const Meta = styled.div`display:flex;flex-wrap:wrap;justify-content:space-between;gap:.5rem 1rem;color:#72808c;font-size:.82rem;`;
const Empty = styled.p`margin:0;padding:1rem;border-radius:.9rem;background:#f4f7f9;color:#586775;`;
const Pending = styled(Empty)`border:1px solid #ead7a6;background:#fff8e8;color:#70531d;`;
const Actions = styled.div`display:flex;justify-content:flex-end;margin-top:1.25rem;`;
const PrimaryButton = styled.button`min-height:2.8rem;padding:.72rem 1.2rem;border:0;border-radius:999px;background:#111;color:#fff;font:inherit;font-weight:800;cursor:pointer;`;

export default SeeReviewArtisan;
